import React from "react";
import Register from "../components/Register/Register";
export default function RegisterPage() {
  return (
    <div className="page-layout">
      <Register />
    </div>
  );
}
